var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tnc_link && _vm.privacy_link
    ? _c(
        "div",
        {
          staticStyle: {
            "background-color": "white",
            padding: "10px",
            "border-radius": "5px",
          },
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.text) } })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }